/* eslint-disable */

export enum ConfiguratorType {
	Default = 0,
	SunScreen = 1,
	PolarPumpInstallation = 2,
	LawnmowerInstallation = 3,
	MasterAttribute = 4,
	SlidingDoor = 5,
	VvsInstallation = 6,
	ZipCodeExclude = 7,
	KitchenContact = 8,
	ShowerDoor = 9,
	Elfa = 10,
	NotForSale = 11,
	
}
